import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DualRating } from 'src/app/shared/models/exercise.model';
import { UtilityService } from 'src/app/shared/utils/utility.service';
// import { DualRating } from 'src/app/models/exercise.model';
// import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-dual-rating',
  templateUrl: './dual-rating.component.html',
  styleUrls: ['./dual-rating.component.css']
})
export class DualRatingComponent implements OnInit {

  @Input() id: string;
  @Input() points: any;
  @Input() exerciseId: any;
  @Input() variableFeedback: any;
  @Input() userFeedback;
  @Output() reportFeedback = new EventEmitter<Object>();
  @Output() likeDislike = new EventEmitter<boolean>();
  @Input() isSubmitted: boolean = false;
  @Input() isResultPublished: boolean = false;
  @Input() immediateFeedBackRequired: boolean = false;
  @Input() showBackButton: boolean = false;
  @Input() fixedEditor: any;
  @Input() index: any;
  @Input() exerciseTimetrackingdata;
  _element: DualRating;
  _answer: string;
  barSelected: string;
  positiveArray = [];
  negativeArray = [];
  centralLabel = [];
  selectedOption: string;
  questionChecked: boolean = false;
  arrType: string;
  finalClickedIndex: any;
  @Input() set element(element) {
    this._element = element;
   
    this.positiveArray = element.options.filter(option => option.align > 0);
    this.negativeArray = element.options.filter(option => option.align < 0).sort((a,b) => a.align - b.align);
    this.centralLabel = element.options.filter(option => option.align == 0);
  }

  @Input() set answer(answer) {
    
    this._answer = answer;
    if(this._answer){
      this.questionChecked = true;
      this.barSelected = this._answer;
    }
  }

  @Output() onValueChange = new EventEmitter<Object>();
  @Output() onReview = new EventEmitter<Object>();
  @Output() back = new EventEmitter<Boolean>(false);
  @Input() questionBlos;

  constructor(private utilityService: UtilityService) { }

  ngOnInit() {
    console.log(this.isSubmitted);
  }

  backHandler() {
    this.back.emit(true);
  }

  next(event) {
    this.onValueChange.emit({ elementId: this.id, answer: event });
  }

  check() {
    this.questionChecked = true;
    this.onReview.emit({ elementId: this.id, answer: this.selectedOption });
  }

  skip() {
    this.onValueChange.emit({ elementId: this.id, answer: '' });
  }

  _reportFeedback(value) {
    this.reportFeedback.emit(value);
  }

  _likeDislike(like) {
    this.likeDislike.emit(like);
  }

showVal(event){
  console.log(event.target.value);
  let clickedIndex = event.target.value;
  switch(clickedIndex) {
    case "0":
      this.centralLabel.forEach((ratingBar, index) => {
        const bar = document.getElementById('rating_id_center' + ratingBar._id);
        if(index >= clickedIndex) {
          this.positiveArray.forEach((ratingBar, index) => {
            const bar = document.getElementById('rating_id_right' + ratingBar._id);
             bar.classList.remove('rating-type__pipe--active');
          });
          this.negativeArray.forEach((ratingBar, index) => {
            const bar = document.getElementById('rating_id_left' + ratingBar._id);
             bar.classList.remove('rating-type__pipe--active');
          });
          bar.classList.add('rating-type__pipe--active');
        } else {
          bar.classList.remove('rating-type__pipe--active');
        }
      });
      this.selectedOption = this.centralLabel[0]._id;
      console.log(this.selectedOption);
      break;
    case "1":
      this.positiveArray.forEach((ratingBar, index) => {
        const bar = document.getElementById('rating_id_right' + ratingBar._id);
        if(index <= clickedIndex-1) {
          this.negativeArray.forEach((ratingBar, index) => {
            const bar = document.getElementById('rating_id_left' + ratingBar._id);
             bar.classList.remove('rating-type__pipe--active');
          })
          bar.classList.add('rating-type__pipe--active');
        } else {
          bar.classList.remove('rating-type__pipe--active');
        }
      });
      this.selectedOption = this.positiveArray[0]._id;
      console.log(this.selectedOption);
      break;
    case "2":
      this.positiveArray.forEach((ratingBar, index) => {
        const bar = document.getElementById('rating_id_right' + ratingBar._id);
        if(index <= clickedIndex-1) {
          this.negativeArray.forEach((ratingBar, index) => {
            const bar = document.getElementById('rating_id_left' + ratingBar._id);
             bar.classList.remove('rating-type__pipe--active');
          })
          bar.classList.add('rating-type__pipe--active');
        } else {
          bar.classList.remove('rating-type__pipe--active');
        }
      });
      this.selectedOption = this.positiveArray[1]._id;
      console.log(this.selectedOption);
      break;
    case "3":
      this.positiveArray.forEach((ratingBar, index) => {
        const bar = document.getElementById('rating_id_right' + ratingBar._id);
        if(index <= clickedIndex-1) {
          this.negativeArray.forEach((ratingBar, index) => {
            const bar = document.getElementById('rating_id_left' + ratingBar._id);
             bar.classList.remove('rating-type__pipe--active');
          })
          bar.classList.add('rating-type__pipe--active');
        } else {
          bar.classList.remove('rating-type__pipe--active');
        }
      });
      this.selectedOption = this.positiveArray[2]._id;
      console.log(this.selectedOption);
      break;
    case "4":
      this.positiveArray.forEach((ratingBar, index) => {
        const bar = document.getElementById('rating_id_right' + ratingBar._id);
        if(index <= clickedIndex-1) {
          this.negativeArray.forEach((ratingBar, index) => {
            const bar = document.getElementById('rating_id_left' + ratingBar._id);
             bar.classList.remove('rating-type__pipe--active');
          })
          bar.classList.add('rating-type__pipe--active');
        } else {
          bar.classList.remove('rating-type__pipe--active');
        }
      });
      this.selectedOption = this.positiveArray[3]._id;
      console.log(this.selectedOption);
      break;
    case "5":
      this.positiveArray.forEach((ratingBar, index) => {
        const bar = document.getElementById('rating_id_right' + ratingBar._id);
        if(index <= clickedIndex-1) {
          this.negativeArray.forEach((ratingBar, index) => {
            const bar = document.getElementById('rating_id_left' + ratingBar._id);
             bar.classList.remove('rating-type__pipe--active');
          })
          bar.classList.add('rating-type__pipe--active');
        } else {
          bar.classList.remove('rating-type__pipe--active');
        }
      });
      this.selectedOption = this.positiveArray[4]._id;
      console.log(this.selectedOption);
      break;
    case "-1":
      this.negativeArray.forEach((ratingBar, index) => {
        const bar = document.getElementById('rating_id_left' + ratingBar._id);
        if(index >= parseInt(clickedIndex)+this.negativeArray.length) {
          this.positiveArray.forEach((ratingBar, index) => {
            const bar = document.getElementById('rating_id_right' + ratingBar._id);
             bar.classList.remove('rating-type__pipe--active');
          })
          bar.classList.add('rating-type__pipe--active');
        } else {
          bar.classList.remove('rating-type__pipe--active');
        }
      });
      this.selectedOption = this.negativeArray[this.negativeArray.length-1]._id;
      console.log(this.selectedOption);
      break;
    case "-2":
      this.negativeArray.forEach((ratingBar, index) => {
        const bar = document.getElementById('rating_id_left' + ratingBar._id);
        if(index >= parseInt(clickedIndex)+this.negativeArray.length) {
          this.positiveArray.forEach((ratingBar, index) => {
            const bar = document.getElementById('rating_id_right' + ratingBar._id);
             bar.classList.remove('rating-type__pipe--active');
          })
          bar.classList.add('rating-type__pipe--active');
        } else {
          bar.classList.remove('rating-type__pipe--active');
        }
      });
      this.selectedOption = this.negativeArray[this.negativeArray.length-2]._id;
      console.log(this.selectedOption);
      break;
    case "-3":
      this.negativeArray.forEach((ratingBar, index) => {
        const bar = document.getElementById('rating_id_left' + ratingBar._id);
        if(index >= parseInt(clickedIndex)+this.negativeArray.length) {
          this.positiveArray.forEach((ratingBar, index) => {
            const bar = document.getElementById('rating_id_right' + ratingBar._id);
             bar.classList.remove('rating-type__pipe--active');
          })
          bar.classList.add('rating-type__pipe--active');
        } else {
          bar.classList.remove('rating-type__pipe--active');
        }
      });
      this.selectedOption = this.negativeArray[this.negativeArray.length-3]._id;
      console.log(this.selectedOption);
      break;
    case "-4":
      this.negativeArray.forEach((ratingBar, index) => {
        const bar = document.getElementById('rating_id_left' + ratingBar._id);
        if(index >= parseInt(clickedIndex)+this.negativeArray.length) {
          this.positiveArray.forEach((ratingBar, index) => {
            const bar = document.getElementById('rating_id_right' + ratingBar._id);
             bar.classList.remove('rating-type__pipe--active');
          })
          bar.classList.add('rating-type__pipe--active');
        } else {
          bar.classList.remove('rating-type__pipe--active');
        }
      });
      this.selectedOption = this.negativeArray[this.negativeArray.length-4]._id;
      console.log(this.selectedOption);
      break;
    case "-5":
      this.negativeArray.forEach((ratingBar, index) => {
        const bar = document.getElementById('rating_id_left' + ratingBar._id);
        if(index >= parseInt(clickedIndex)+this.negativeArray.length) {
          this.positiveArray.forEach((ratingBar, index) => {
            const bar = document.getElementById('rating_id_right' + ratingBar._id);
             bar.classList.remove('rating-type__pipe--active');
          })
          bar.classList.add('rating-type__pipe--active');
        } else {
          bar.classList.remove('rating-type__pipe--active');
        }
      });
      this.selectedOption = this.negativeArray[this.negativeArray.length-5]._id;
      console.log(this.selectedOption);
      break;
    default:
      this.negativeArray.forEach((ratingBar, index) => {
        const bar = document.getElementById('rating_id_left' + ratingBar._id);
        if(index >= clickedIndex+this.negativeArray.length) {
          this.positiveArray.forEach((ratingBar, index) => {
            const bar = document.getElementById('rating_id_right' + ratingBar._id);
             bar.classList.remove('rating-type__pipe--active');
          })
          bar.classList.add('rating-type__pipe--active');
        } else {
          bar.classList.remove('rating-type__pipe--active');
        }
      })
      break;
  }
}

}
